// extracted by mini-css-extract-plugin
export default {"hoverable":"QAMR2K6BUD"};